import { FC } from 'react';
import colors from 'styles/_colors.module.scss';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const ArrowDownIcon: FC<Props> = ({
  width = 8,
  height = 6,
  color = colors['--white'],
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 8 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 5.08a.665.665 0 0 1-.471-.195L.7 2.057a.667.667 0 0 1 .943-.942L4 3.47l2.357-2.356a.667.667 0 0 1 .943.942L4.471 4.885A.665.665 0 0 1 4 5.081Z"
      fill={color}
    />
  </svg>
);

export default ArrowDownIcon;
